import { render, staticRenderFns } from "./index.vue?vue&type=template&id=10e9219e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=10e9219e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e9219e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/erp-flexible-web21_zo1Z/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10e9219e')) {
      api.createRecord('10e9219e', component.options)
    } else {
      api.reload('10e9219e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=10e9219e&scoped=true", function () {
      api.rerender('10e9219e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SqlEditor/index.vue"
export default component.exports